import React from "react";
import { Link } from "react-router-dom";

import account from "../../../assets/account.jpg";
import automotive from "../../../assets/automotive.jpg";
import building from "../../../assets/building.jpg";
import education from "../../../assets/education.jpg";
import food from "../../../assets/food.jpg";
import it from "../../../assets/it.jpg";
import Nursingg from "../../../assets/Nursingg.jpg";
import socialWork from "../../../assets/socialWork.jpg";
import engineer from "../../../assets/engineer.jpg";
import occupationalTher from "../../../assets/occupationalTher.jpg";

import "./Pathway.css";

const Pathway = () => {
  return (
    <>
      <section class="section">
        <div class="container">
          <div className="max-w more" style={{ marginBottom: "20px" }}>
            <div
              data-w-id="166d813f-4ff4-c949-5b3d-e38231847ba1"
              className="flex-tag"
            >
              <div className="bullet-tag color"></div>
              <h2 className="main-title">Pathway to PR Courses</h2>
            </div>
          </div>
          <div>
            <div class="w-dyn-list">
              <div role="list" class="blog-list w-dyn-items">
                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={education} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Childhood Education & Care</h3>
                      <p className="card-text">
                        Education is, as it should be, a most crucial career
                        field; because working in this area of expertise brings
                        with it the power to shape future generations.
                      </p>
                      <Link to="/EarlyChild" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={Nursingg} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Nursing</h3>
                      <p className="card-text">
                        Inspire your enthusiasm to pursue Nursing courses in
                        Melbourne, Australia and nurture your career pathway in
                        this demanding sector.
                      </p>
                      <Link to="/Nursing" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={socialWork} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Social Work</h3>
                      <p className="card-text">
                        Given the growing vulnerabilities in human behavior,
                        pursuing Social Work courses in Sydney, Australia could
                        be instrumental in helping individuals towards a better
                        life.
                      </p>
                      <Link to="/SocialWork" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={building} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Building & Construction</h3>
                      <p className="card-text">
                        Nowadays, being an expert in any trade can be a key
                        factor that helps you earn competitive and higher
                        salaries than possible otherwise.
                      </p>
                      <Link to="/BuildConstru" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={it} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Information Technology</h3>
                      <p className="card-text">
                        Irrespective of the point in time you decide to choose
                        Australia as a destination, there are multitudes of
                        options that you could opt for in the field of
                        Information Technology (IT).
                      </p>
                      <Link to="/InfoTech" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={engineer} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Engineering</h3>
                      <p className="card-text">
                        Studying engineering in Australia can lead to
                        substantial career enhancements as it has a great demand
                        in the industry.
                      </p>
                      <Link to="/Engineer" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={account} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Accounting</h3>
                      <p className="card-text">
                        Accountancy or Accounting, one of Australia’s most
                        popular courses, has always been an essential part of
                        the skilled occupations list as recommended by
                        immigration in the country.
                      </p>
                      <Link to="/Accounting" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img
                      src={occupationalTher}
                      alt="Card"
                      className="card-img"
                    />
                    <div className="card-content">
                      <h3 className="card-title">Occupational Therapy</h3>
                      <p className="card-text">
                        Occupational Therapy is a popular and rewarding field of
                        study in Australia. If you are passionate about helping
                        others lead better lives—both mentally and
                        physically—this career is an excellent choice.
                      </p>
                      <Link to="/OccupationalTherapy" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={automotive} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">Automotive Engineering</h3>
                      <p className="card-text">
                        If your field of interest and fascination is cars or how
                        they work, then an academic degree followed by a
                        professional career in the automotive industry might be
                        the answer.
                      </p>
                      <Link to="/AutoTech" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>

                <div role="listitem" className="w-dyn-item">
                  <div className="card">
                    <img src={food} alt="Card" className="card-img" />
                    <div className="card-content">
                      <h3 className="card-title">
                        Food & Hospitality Management
                      </h3>
                      <p className="card-text">
                        A career in the cookery industry can be extremely
                        challenging and adventurous at the same time. A
                        rewarding career in Australia’s fast-paced food and
                        hospitality sector awaits you.
                      </p>
                      <Link to="/Cookery" className="learn-more">
                        Learn More
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Pathway;
